import { render, staticRenderFns } from "./VerifyCode.vue?vue&type=template&id=37aa03e4&scoped=true&"
import script from "./VerifyCode.vue?vue&type=script&lang=js&"
export * from "./VerifyCode.vue?vue&type=script&lang=js&"
import style0 from "./VerifyCode.vue?vue&type=style&index=0&id=37aa03e4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37aa03e4",
  null
  
)

export default component.exports